<template>
  <b-modal
    id="modal-criar-produto"
    title="Novo Produto"
    size="xl"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="resetForm"
    @show="carregarOpcoes"
  >
    <b-tabs v-model="tabAtiva" pills card>

      <!-- ===================== ABA 1: PRODUTO ===================== -->
      <b-tab title="1. Produto">
        <validation-observer ref="formObserver">
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12" class="mb-1">
                <h6 class="text-primary font-weight-bold">Identificação</h6>
                <hr class="mt-0" />
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="ID do Produto *" label-for="p-id">
                  <validation-provider #default="{ errors }" name="ID do Produto" rules="required">
                    <b-form-input id="p-id" v-model="form.item_id" placeholder="Ex: 1000"
                      :state="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6" class="mb-1">
                <b-form-group label="Descrição *" label-for="p-desc">
                  <validation-provider #default="{ errors }" name="Descrição" rules="required">
                    <b-form-input id="p-desc" v-model="form.item_descricao" placeholder="Descrição do produto"
                      :state="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Situação" label-for="p-sit">
                  <v-select id="p-sit" v-model="form.item_situacao"
                    :options="['ATIVO','INATIVO']" placeholder="ATIVO" />
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mb-1 mt-1">
                <h6 class="text-primary font-weight-bold">Classificação</h6>
                <hr class="mt-0" />
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Família Comercial *" label-for="p-fcom">
                  <validation-provider #default="{ errors }" name="Família Comercial" rules="required">
                    <v-select id="p-fcom" v-model="form.familia_comercial_id"
                      :options="familiaComercialOpts" :reduce="o => o.value" label="label"
                      placeholder="Selecione..." :loading="carregando.familiaComercial"
                      :filter-by="filtrarOpcao"
                      :class="errors.length > 0 ? 'is-invalid' : ''" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Família Material *" label-for="p-fmat">
                  <validation-provider #default="{ errors }" name="Família Material" rules="required">
                    <v-select id="p-fmat" v-model="form.familia_material_id"
                      :options="familiaMaterialOpts" :reduce="o => o.value" label="label"
                      placeholder="Selecione..." :loading="carregando.familiaMaterial"
                      :filter-by="filtrarOpcao"
                      :class="errors.length > 0 ? 'is-invalid' : ''" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Grupo de Estoque *" label-for="p-gest">
                  <validation-provider #default="{ errors }" name="Grupo de Estoque" rules="required">
                    <v-select id="p-gest" v-model="form.grupo_estoque_id"
                      :options="grupoEstoqueOpts" :reduce="o => o.value" label="label"
                      placeholder="Selecione..." :loading="carregando.grupoEstoque"
                      :filter-by="filtrarOpcao"
                      :class="errors.length > 0 ? 'is-invalid' : ''" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Classificação Fiscal *" label-for="p-cfis">
                  <validation-provider #default="{ errors }" name="Classificação Fiscal" rules="required">
                    <v-select id="p-cfis" v-model="form.classificacao_fiscal_id"
                      :options="classificacaoFiscalOpts" :reduce="o => o.value" label="label"
                      placeholder="Selecione..." :loading="carregando.classificacaoFiscal"
                      :filter-by="filtrarOpcao"
                      :class="errors.length > 0 ? 'is-invalid' : ''" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Categoria" label-for="p-categ">
                  <v-select id="p-categ" v-model="form.cod_categ"
                    :options="categoriaOpts" :reduce="o => o.value" label="label"
                    placeholder="Selecione..." :loading="carregando.categoria"
                    :filter-by="filtrarOpcao" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Unidade de Medida *" label-for="p-unmed">
                  <validation-provider #default="{ errors }" name="Unidade de Medida" rules="required">
                    <v-select id="p-unmed" v-model="form.unidade_medida_id"
                      :options="unidadeMedidaOpts" :reduce="o => o.value" label="label"
                      placeholder="Selecione..." :loading="carregando.unidadeMedida"
                      :filter-by="filtrarOpcao"
                      :class="errors.length > 0 ? 'is-invalid' : ''" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mb-1 mt-1">
                <h6 class="text-primary font-weight-bold">Características Físicas</h6>
                <hr class="mt-0" />
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Cor" label-for="p-cor">
                  <v-select id="p-cor" v-model="form.cdn_cor"
                    :options="corOpts" :reduce="o => o.value" label="label"
                    placeholder="Selecione..." :loading="carregando.cor"
                    :filter-by="filtrarOpcao" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Embalagem" label-for="p-emb">
                  <v-select id="p-emb" v-model="form.cdn_embalagem"
                    :options="embalagemOpts" :reduce="o => o.value" label="label"
                    placeholder="Selecione..." :loading="carregando.embalagem"
                    :filter-by="filtrarOpcao" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Tamanho" label-for="p-tam">
                  <v-select id="p-tam" v-model="form.cdn_tamanho"
                    :options="tamanhoOpts" :reduce="o => o.value" label="label"
                    placeholder="Selecione..." :loading="carregando.tamanho"
                    :filter-by="filtrarOpcao" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Estoque" label-for="p-estq">
                  <b-form-input id="p-estq" v-model="form.estoque" type="number" placeholder="0" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Peso Bruto" label-for="p-pb">
                  <b-form-input id="p-pb" v-model="form.item_peso_bruto" type="number" step="0.001" placeholder="0.000" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Peso Líquido" label-for="p-pl">
                  <b-form-input id="p-pl" v-model="form.item_peso_liquido" type="number" step="0.001" placeholder="0.000" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Comprimento" label-for="p-comp">
                  <b-form-input id="p-comp" v-model="form.item_comprimento" type="number" step="0.01" placeholder="0.00" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="mb-1">
                <b-form-group label="Largura" label-for="p-larg">
                  <b-form-input id="p-larg" v-model="form.item_largura" type="number" step="0.01" placeholder="0.00" />
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mb-1 mt-1">
                <h6 class="text-primary font-weight-bold">Fiscal</h6>
                <hr class="mt-0" />
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Cód. Tributação ICMS" label-for="p-tribicms">
                  <v-select id="p-tribicms" v-model="form.item_cod_tributacao_icms"
                    :options="['Tributado','Reduzido','Isento','Não tributado']"
                    placeholder="Selecione..." />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Alíquota IPI (%)" label-for="p-ipi">
                  <b-form-input id="p-ipi" v-model="form.item_aliquota_ipi" type="number" step="0.01" placeholder="0.00" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Gramatura" label-for="p-gram">
                  <b-form-input id="p-gram" v-model="form.item_gramatura" type="number" step="0.01" placeholder="0.00" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1">
                <b-form-group label="Lote Múltiplo" label-for="p-lmul">
                  <b-form-input id="p-lmul" v-model="form.item_lote_multiplo" type="number" placeholder="0" />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="4" class="mb-1 d-flex align-items-center" style="padding-top:22px">
                <b-form-checkbox v-model="form.log_dispon_b2b" :value="1" :unchecked-value="0" switch>
                  Disponível no B2B
                </b-form-checkbox>
              </b-col>

              <b-col cols="12" class="mb-1">
                <b-form-group label="Inf. Complementar" label-for="p-inf">
                  <b-form-textarea id="p-inf" v-model="form.item_inf_complementar" rows="2" placeholder="Informações complementares..." />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-tab>

      <!-- ===================== ABA 2: IMAGEM ===================== -->
      <b-tab title="2. Imagem">
        <b-row>
          <b-col cols="12" class="mb-1">
            <h6 class="text-primary font-weight-bold">Template de Imagem</h6>
            <small class="text-muted">Informe a URL da imagem e metadados do produto. Opcional.</small>
            <hr class="mt-1" />
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="URL da Imagem Principal" label-for="img-url">
              <b-form-input id="img-url" v-model="imagem.caminho" placeholder="https://..." />
            </b-form-group>
          </b-col>

          <b-col cols="12" v-if="imagem.caminho" class="mb-2 text-center">
            <b-img :src="imagem.caminho" fluid rounded style="max-height:180px; object-fit:contain" alt="Preview" />
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Marca" label-for="img-marca">
              <v-select id="img-marca" v-model="imagem.cod_marca"
                :options="marcaOpts" :reduce="o => o.value" label="label"
                placeholder="Selecione..." :loading="carregando.marca"
                :filter-by="filtrarOpcao" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Família Comercial" label-for="img-fcom">
              <v-select id="img-fcom" v-model="imagem.familia_comercial_id"
                :options="familiaComercialOpts" :reduce="o => o.value" label="label"
                placeholder="Selecione..." :filter-by="filtrarOpcao" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Cor" label-for="img-cor">
              <v-select id="img-cor" v-model="imagem.cdn_cor"
                :options="corOpts" :reduce="o => o.value" label="label"
                placeholder="Selecione..." :filter-by="filtrarOpcao" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Embalagem" label-for="img-emb">
              <v-select id="img-emb" v-model="imagem.cdn_embalag"
                :options="embalagemOpts" :reduce="o => o.value" label="label"
                placeholder="Selecione..." :filter-by="filtrarOpcao" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="2" class="mb-1">
            <b-form-group label="Ordem" label-for="img-ordem">
              <b-form-input id="img-ordem" v-model="imagem.ordem" type="number" placeholder="1" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="2" class="mb-1 d-flex align-items-center" style="padding-top:22px">
            <b-form-checkbox v-model="imagem.imagem_principal" :value="1" :unchecked-value="0" switch>
              Principal
            </b-form-checkbox>
          </b-col>

          <b-col cols="12" md="2" class="mb-1 d-flex align-items-center" style="padding-top:22px">
            <b-form-checkbox v-model="imagem.exibe_cores" :value="1" :unchecked-value="0" switch>
              Exibe Cores
            </b-form-checkbox>
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="Descrição" label-for="img-desc">
              <b-form-textarea id="img-desc" v-model="imagem.descricao" rows="2" placeholder="Descrição do produto para catálogo..." />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="Característica" label-for="img-caract">
              <b-form-input id="img-caract" v-model="imagem.caracteristica" placeholder="Ex: Livro" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="Composição" label-for="img-comp">
              <b-form-input id="img-comp" v-model="imagem.composicao" placeholder="Ex: Papel" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="Benefícios" label-for="img-benef">
              <b-form-input id="img-benef" v-model="imagem.beneficios" placeholder="Ex: Educação" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="Indicações" label-for="img-indic">
              <b-form-input id="img-indic" v-model="imagem.indicacoes" placeholder="Ex: Todas as idades" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

      <!-- ===================== ABA 3: PREÇO ===================== -->
      <b-tab title="3. Preço na Tabela">
        <b-row>
          <b-col cols="12" class="mb-1">
            <h6 class="text-primary font-weight-bold">Inserir Produto em Tabela de Preço</h6>
            <small class="text-muted">Opcional — adicione este produto a uma tabela de preço existente.</small>
            <hr class="mt-1" />
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="Tabela de Preço" label-for="preco-tabela">
              <v-select id="preco-tabela" v-model="preco.tabelapreco_id"
                :options="tabelaPrecoOpts" :reduce="o => o.value" label="label"
                placeholder="Selecione..." :loading="carregando.tabela"
                :filter-by="filtrarOpcao" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-1">
            <b-form-group label="Início Validade" label-for="preco-inicio">
              <b-form-input id="preco-inicio" v-model="preco.tabelapreco_inicio_validade" type="date" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-1">
            <b-form-group label="Unidade de Medida" label-for="preco-unmed">
              <v-select id="preco-unmed" v-model="preco.unidade_medida_id"
                :options="unidadeMedidaOpts" :reduce="o => o.value" label="label"
                placeholder="Selecione..." :filter-by="filtrarOpcao" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-1">
            <b-form-group label="Preço (R$) *" label-for="preco-valor">
              <b-form-input id="preco-valor" v-model="preco.tabelapreco_item_preco"
                type="number" step="0.01" min="0" placeholder="0.00" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-1">
            <b-form-group label="Qtd. Mínima" label-for="preco-qtmin">
              <b-form-input id="preco-qtmin" v-model="preco.tabelapreco_item_qtdeminima"
                type="number" min="0" placeholder="1" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-1">
            <b-form-group label="Situação" label-for="preco-sit">
              <v-select id="preco-sit" v-model="preco.tabelapreco_item_situacao"
                :options="['ATIVO','INATIVO']" placeholder="ATIVO" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-1">
            <b-form-group label="Referência ID" label-for="preco-ref">
              <b-form-input id="preco-ref" v-model="preco.referencia_id" placeholder="Opcional" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

    </b-tabs>

    <!-- Progresso de salvamento -->
    <b-alert v-if="progressoSalvamento.length" show variant="light" class="mt-1 p-1">
      <div v-for="(p, i) in progressoSalvamento" :key="i" class="d-flex align-items-center mb-25">
        <b-spinner v-if="p.status === 'loading'" small class="mr-50" />
        <feather-icon v-else-if="p.status === 'ok'" icon="CheckCircleIcon" size="16" class="text-success mr-50" />
        <feather-icon v-else-if="p.status === 'erro'" icon="XCircleIcon" size="16" class="text-danger mr-50" />
        <span :class="{ 'text-success': p.status === 'ok', 'text-danger': p.status === 'erro' }">{{ p.msg }}</span>
      </div>
    </b-alert>

    <template #modal-footer>
      <b-button variant="outline-secondary" :disabled="tabAtiva === 0 || salvando" @click="tabAtiva = Math.max(0, tabAtiva - 1)">
        Anterior
      </b-button>
      <b-button v-if="tabAtiva < 2" variant="primary" @click="tabAtiva = Math.min(2, tabAtiva + 1)">
        Próximo
      </b-button>
      <b-button variant="secondary" :disabled="salvando" @click="$bvModal.hide('modal-criar-produto')">
        Cancelar
      </b-button>
      <b-button variant="success" :disabled="salvando" @click="salvar">
        <b-spinner v-if="salvando" small class="mr-1" />
        {{ salvando ? 'Salvando...' : 'Salvar' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox,
  BFormTextarea, BButton, BSpinner, BTabs, BTab, BAlert, BImg,
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import axios from '@/libs/axios';

export default {
  name: 'ModalCriarProduto',
  components: {
    BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox,
    BFormTextarea, BButton, BSpinner, BTabs, BTab, BAlert, BImg,
    ValidationObserver, ValidationProvider,
    vSelect,
  },
  data() {
    return {
      tabAtiva: 0,
      salvando: false,
      progressoSalvamento: [],
      form: this.emptyForm(),
      imagem: this.emptyImagem(),
      preco: this.emptyPreco(),
      required,
      familiaComercialOpts: [],
      familiaMaterialOpts: [],
      grupoEstoqueOpts: [],
      classificacaoFiscalOpts: [],
      categoriaOpts: [],
      unidadeMedidaOpts: [],
      corOpts: [],
      embalagemOpts: [],
      tamanhoOpts: [],
      marcaOpts: [],
      tabelaPrecoOpts: [],
      carregando: {
        familiaComercial: false, familiaMaterial: false, grupoEstoque: false,
        classificacaoFiscal: false, categoria: false, unidadeMedida: false,
        cor: false, embalagem: false, tamanho: false, marca: false, tabela: false,
      },
    };
  },
  methods: {
    emptyForm() {
      return {
        item_id: '',
        item_descricao: '',
        item_situacao: 'ATIVO',
        familia_comercial_id: null,
        familia_material_id: null,
        grupo_estoque_id: null,
        classificacao_fiscal_id: null,
        cod_categ: null,
        unidade_medida_id: null,
        cdn_cor: null,
        cdn_embalagem: null,
        cdn_tamanho: null,
        estoque: 0,
        item_peso_bruto: 0,
        item_peso_liquido: 0,
        item_comprimento: null,
        item_largura: 0,
        item_gramatura: 0,
        item_aliquota_ipi: 0,
        item_lote_multiplo: 0,
        item_cod_tributacao_icms: 'Tributado',
        item_inf_complementar: '',
        log_dispon_b2b: 1,
      };
    },
    emptyImagem() {
      return {
        caminho: '',
        familia_comercial_id: null,
        cod_marca: null,
        cdn_cor: null,
        cdn_embalag: null,
        imagem_principal: 1,
        exibe_cores: 1,
        ordem: 1,
        descricao: '',
        caracteristica: '',
        composicao: '',
        beneficios: '',
        indicacoes: '',
        categoria: 0,
      };
    },
    emptyPreco() {
      return {
        tabelapreco_id: null,
        tabelapreco_inicio_validade: new Date().toISOString().slice(0, 10),
        item_id: '',
        referencia_id: '',
        unidade_medida_id: null,
        tabelapreco_item_qtdeminima: 1,
        tabelapreco_item_preco: 0,
        tabelapreco_item_preco_pend: 0,
        tabelapreco_item_qtdeminima_pend: 0,
        tabelapreco_item_situacao: 'ATIVO',
        tabelapreco_item_ativo: 1,
        tabelapreco_item_variacao_minima: 0,
        tabelapreco_item_variacao_maxima: 0,
      };
    },
    resetForm() {
      this.tabAtiva = 0;
      this.form = this.emptyForm();
      this.imagem = this.emptyImagem();
      this.preco = this.emptyPreco();
      this.salvando = false;
      this.progressoSalvamento = [];
      if (this.$refs.formObserver) this.$refs.formObserver.reset();
    },
    filtrarOpcao(option, label, search) {
      return label.toLowerCase().includes(search.toLowerCase());
    },
    adicionarProgresso(msg, status = 'loading') {
      this.progressoSalvamento.push({ msg, status });
      return this.progressoSalvamento.length - 1;
    },
    atualizarProgresso(idx, status, msg) {
      if (msg) this.progressoSalvamento[idx].msg = msg;
      this.progressoSalvamento[idx].status = status;
      this.$forceUpdate();
    },
    async carregarOpcoes() {
      await Promise.all([
        this.carregar('familia-comercial?perPage=5000', 'familiaComercial', 'data', d => ({ label: `${d.familia_comercial_id} — ${d.familia_comercial_descricao}`, value: d.familia_comercial_id })),
        this.carregar('familia-material?perPage=5000', 'familiaMaterial', 'data', d => ({ label: `${d.familia_material_id} — ${d.familia_material_descricao}`, value: d.familia_material_id })),
        this.carregar('grupo-estoque?perPage=1000', 'grupoEstoque', 'data', d => ({ label: `${d.grupo_estoque_id} — ${d.grupo_estoque_descricao}`, value: d.grupo_estoque_id })),
        this.carregar('classificacao-fiscal?perPage=10000', 'classificacaoFiscal', 'data', d => ({ label: `${d.classificacao_fiscal_id} — ${d.classificacao_fiscal_descricao}`, value: d.classificacao_fiscal_id })),
        this.carregar('categorias?perPage=1000', 'categoria', 'data', d => ({ label: `${d.cod_categ} — ${d.descricao}`, value: d.cod_categ })),
        this.carregar('unidade-medida?perPage=200', 'unidadeMedida', 'data', d => ({ label: `${d.unidade_medida_sigla || d.unidade_medida_id} — ${d.unidade_medida_descricao}`, value: d.unidade_medida_id })),
        this.carregar('cores?perPage=2000', 'cor', 'data', d => ({ label: `${d.cdn_cor} — ${d.des_cor}`, value: d.cdn_cor }), 'corOpts'),
        this.carregar('embalagens?perPage=1000', 'embalagem', 'data', d => ({ label: `${d.cdn_embalag} — ${d.des_embalag}`, value: d.cdn_embalag }), 'embalagemOpts'),
        this.carregar('tamanhos?perPage=1000', 'tamanho', 'data', d => ({ label: `${d.cdn_tamanho} — ${d.des_tamanho}`, value: d.cdn_tamanho }), 'tamanhoOpts'),
        this.carregar('marcas?perPage=200', 'marca', 'data', d => ({ label: `${d.cod_marca} — ${d.des_marca}`, value: d.cod_marca }), 'marcaOpts'),
        this.carregar('tabela-preco?perPage=1000', 'tabela', 'data', d => ({ label: `${d.tabelapreco_id} — ${d.tabelapreco_descricao}`, value: d.tabelapreco_id }), 'tabelaPrecoOpts'),
      ]);
    },
    async carregar(endpoint, loadingKey, dataKey, mapper, targetKey) {
      const prop = targetKey || (loadingKey + 'Opts');
      this.carregando[loadingKey] = true;
      try {
        const { data } = await axios.get('/' + endpoint);
        const lista = data?.[dataKey] || (Array.isArray(data) ? data : []);
        this[prop] = lista.map(mapper);
      } catch (e) {
        this[prop] = [];
      } finally {
        this.carregando[loadingKey] = false;
      }
    },
    async salvar() {
      const valid = await this.$refs.formObserver.validate();
      if (!valid) {
        this.tabAtiva = 0;
        this.$bvToast.toast('Corrija os campos obrigatórios na aba "Produto".', {
          title: 'Atenção', variant: 'warning', solid: true,
        });
        return;
      }

      this.salvando = true;
      this.progressoSalvamento = [];

      let itemIdCriado = null;

      try {
        // 1. Criar Produto (sls_item)
        const idxItem = this.adicionarProgresso('Criando produto...');
        try {
          const { data } = await axios.post('/items', this.form);
          itemIdCriado = data?.item_id || this.form.item_id;
          this.atualizarProgresso(idxItem, 'ok', `Produto criado (ID: ${itemIdCriado})`);
        } catch (e) {
          const msg = e?.response?.data?.error || e.message;
          this.atualizarProgresso(idxItem, 'erro', `Erro ao criar produto: ${msg}`);
          throw e;
        }

        // 2. Criar Template de Imagem (sls_template_imagem) - opcional
        if (this.imagem.caminho) {
          const idxImg = this.adicionarProgresso('Salvando imagem...');
          try {
            await axios.post('/template-imagem', {
              ...this.imagem,
              familia_comercial_id: this.imagem.familia_comercial_id || this.form.familia_comercial_id,
              cdn_cor: this.imagem.cdn_cor || this.form.cdn_cor,
            });
            this.atualizarProgresso(idxImg, 'ok', 'Template de imagem salvo');
          } catch (e) {
            const msg = e?.response?.data?.message || e?.response?.data?.error || e.message;
            this.atualizarProgresso(idxImg, 'erro', `Imagem não salva: ${msg}`);
          }
        }

        // 3. Criar Tabela de Preço Item (sls_tabelapreco_item) - opcional
        if (this.preco.tabelapreco_id && this.preco.tabelapreco_item_preco > 0) {
          const idxPreco = this.adicionarProgresso(`Adicionando à tabela ${this.preco.tabelapreco_id}...`);
          try {
            await axios.post('/tabela-preco-item', {
              ...this.preco,
              item_id: itemIdCriado,
            });
            this.atualizarProgresso(idxPreco, 'ok', `Preço R$ ${Number(this.preco.tabelapreco_item_preco).toFixed(2)} adicionado`);
          } catch (e) {
            const msg = e?.response?.data?.message || e?.response?.data?.error || e.message;
            this.atualizarProgresso(idxPreco, 'erro', `Preço não salvo: ${msg}`);
          }
        }

        this.$bvToast.toast('Produto criado com sucesso!', {
          title: 'Sucesso', variant: 'success', solid: true,
        });
        this.$emit('criado');

        setTimeout(() => {
          this.$bvModal.hide('modal-criar-produto');
        }, 1500);

      } catch (e) {
        this.$bvToast.toast('Erro ao criar produto. Verifique os dados.', {
          title: 'Erro', variant: 'danger', solid: true,
        });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
